import { render, staticRenderFns } from "./IpRangeHandler.vue?vue&type=template&id=30ca36f6"
import script from "./IpRangeHandler.vue?vue&type=script&lang=ts"
export * from "./IpRangeHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports